import * as tslib_1 from "tslib";
import { OnInit, ElementRef } from '@angular/core';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { MatPaginator, MatSort, MatDialogConfig } from '@angular/material';
var EmsIndividualDashboardComponent = /** @class */ (function () {
    function EmsIndividualDashboardComponent(datePipe, ngxLoader, deviceManagerSer, transMngSer, matDialog, EmsdashboardService) {
        this.datePipe = datePipe;
        this.ngxLoader = ngxLoader;
        this.deviceManagerSer = deviceManagerSer;
        this.transMngSer = transMngSer;
        this.matDialog = matDialog;
        this.EmsdashboardService = EmsdashboardService;
        this.myData = [];
        this.heading_dummy_alert = ['startTime', 'type', 'threshold', 'actual'];
        this.count_m = 1;
        this.meterno = "1";
        this.energyMeterId = [];
        this.systemkvahf = 0;
        this.systemkvahl = 0;
        this.selectedEnergyMeter = "1";
        this.lengtho = 0;
        this.totalkwhcurrentmonth = 0;
        this.showInfo = 'first';
        this.animationRunning = true;
        this.animationRunnings = true;
        this.KWHValuer = 0;
        this.KWHValuel = 0;
        this.selectedTimeDuration = "Today";
        this.latestkwh_p = 0;
        this.LiveAlertsArray = [];
        this.majorTicks = {
            interval: 10,
            color: 'red',
            height: 10,
            width: 3,
            position: 'Inside',
            offset: 5
        };
        this.minorTicks = {
            interval: 5,
            color: 'green',
            height: 5,
            width: 2,
            position: 'Inside',
            offset: 5
        };
        this.labelStyles = {
            position: 'Inside',
            format: '{value}',
            offset: 4,
            color: 'red',
            width: 2
        };
        this.cap = {
            radius: 5,
            border: {
                color: 'red',
                width: 3
            }
        };
        this.heading = [];
        this.blinkState = 'visible';
        this.timeOptions = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];
        this.speakerOn = true;
        this.muteSuggestions = false;
    }
    EmsIndividualDashboardComponent.prototype.toggleSpeaker = function () {
        this.speakerOn = !this.speakerOn;
        this.muteSuggestions = !this.speakerOn;
    };
    EmsIndividualDashboardComponent.prototype.getAlertClass = function (type) {
        return type === 'Overload' ? 'alert-error' : 'alert-warning';
    };
    EmsIndividualDashboardComponent.prototype.getAlertMessage = function (type) {
        var message = type;
        message = message.substring(2);
        return message = "Parameter: " + message;
    };
    EmsIndividualDashboardComponent.prototype.getAlertValue = function (type, actual) {
        return type === 'Overload' ? "Actual Value: " + type + "A" : "Actual Value: " + actual;
    };
    EmsIndividualDashboardComponent.prototype.stopAnimations = function () {
        this.animationRunnings = false;
        var alertsLists = document.getElementById('suggestion-list');
        if (alertsLists) {
            alertsLists.classList.remove('suggestionlists');
        }
    };
    EmsIndividualDashboardComponent.prototype.startAnimations = function () {
        this.animationRunnings = true;
        var alertsLists = document.getElementById('suggestion-list');
        if (alertsLists) {
            alertsLists.classList.add('suggestionlists');
        }
    };
    EmsIndividualDashboardComponent.prototype.ngAfterViewInit = function () {
        this.graphDiv = this.chart;
        this.energyconsumption = this.energyconsumption_graph;
        this.individual_graph_g = this.individual_graph;
    };
    EmsIndividualDashboardComponent.prototype.ngOnInit = function () {
        this.blink();
        this.getDeiceIds();
        this.graphIndividual();
    };
    EmsIndividualDashboardComponent.prototype.getDeiceIds = function () {
        var _this = this;
        this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe(function (response) {
            if (response.result.length > 0) {
                var Deviceids_1 = [];
                response.result.forEach(function (value) {
                    Deviceids_1.push(value.deviceId + "(" + value.sitename + ")");
                });
                _this.Deviceid = Deviceids_1[0];
                _this.uniqueDeviceId = Deviceids_1;
                console.log("?????????????????", _this.uniqueDeviceId);
                _this.selectedDevice = Deviceids_1[0];
                _this.getselectedDeviceIddata(Deviceids_1[0]);
            }
        });
    };
    EmsIndividualDashboardComponent.prototype.getselectedDeviceIddata = function (deviceid) {
        var _this = this;
        this.selectedDevice = deviceid;
        deviceid = deviceid.split('(')[0];
        this.transMngSer.getEnergyMeters(deviceid).toPromise().then(function (response1) {
            if (response1.result.length > 0) {
                var energyMeterId_1 = [];
                response1.result.forEach(function (value) {
                    energyMeterId_1.push(value.meterSerialNumber + "(" + value.assetName + ")");
                });
                _this.energyMeterIdArray = energyMeterId_1;
                console.log("this.energyMeterIdArray", _this.energyMeterIdArray);
                _this.meterCountValue = _this.energyMeterIdArray.length;
                _this.selectedEnergyMeter = energyMeterId_1[0];
                _this.lastmeter = _this.selectedEnergyMeter;
                _this.EmsdashboardService.getParameterConfig(_this.selectedEnergyMeter.split('(')[0]).toPromise().then(function (response1) {
                    if (response1.result.length > 0) {
                        var Parameters = response1.result[0];
                        delete Parameters['deletedflag'];
                        delete Parameters['id'];
                        delete Parameters['energyMeterId'];
                        var paramKeys = [];
                        for (var keys in Parameters) {
                            if (Parameters[keys] == 1) {
                                paramKeys.push(keys);
                            }
                        }
                        _this.parametersList = paramKeys;
                        _this.selectedParameter = _this.parametersList[0];
                        _this.selectedTimeDuration = _this.timeOptions[0];
                        _this.getSelectedMeterDetail();
                        _this.updateMeterSelectData();
                    }
                });
            }
        });
    };
    EmsIndividualDashboardComponent.prototype.graphIndividual = function () {
        var options = {
            series: [{
                    name: "Value",
                    data: [0]
                }],
            chart: {
                type: 'area',
                height: "100%",
                zoom: {
                    enabled: false
                }
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                curve: 'smooth'
            },
            title: {
                text: 'Individual Meter Graph Data',
                style: {
                    color: "black",
                    fontWeight: 'bold'
                },
                align: 'left',
            },
            xaxis: {
                type: 'DateTime',
                tickAmount: 2.2,
                tickPlacement: 'between',
                intervalType: 'Hours',
                labels: {
                    show: true,
                    style: {
                        colors: 'black',
                        fontWeight: 'bold'
                    },
                    rotate: 0,
                }
            },
            yaxis: {
                labels: {
                    style: {
                        colors: 'black'
                    }
                }
            },
            legend: {
                horizontalAlign: 'left'
            }
        };
        this.chart_i = new ApexCharts(this.individual_graph.nativeElement, options);
        this.chart_i.render();
    };
    EmsIndividualDashboardComponent.prototype.getSelectedMeterDetail = function () {
        var _this = this;
        console.log("this.selectedEnergyMeter", this.selectedEnergyMeter);
        console.log("this.selectedEnergyMeter split", this.selectedEnergyMeter.split('(')[0]);
        this.EmsdashboardService.getemsmonthdata({ "meterid": [this.selectedEnergyMeter.split('(')[0]] }).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var count, avgpfm;
            return tslib_1.__generator(this, function (_a) {
                console.log("response from getemsmonthdata", response);
                count = Number(response.data[0].count);
                avgpfm = 0;
                if (response.data[0].avgpf && count > 0) {
                    avgpfm = Number(response.data[0].avgpf / count);
                }
                this.latestkwh_p = Number(response.data[0].kwh).toFixed(2);
                this.pf = Number(avgpfm).toFixed(2);
                this.skVAh = Number(response.data[0].kvah).toFixed(2);
                this.totalkwhcurrentmonth = Number(response.data[0].logsystemkwh).toFixed(2);
                return [2 /*return*/];
            });
        }); });
        this.updateMeterSelectData();
        this.getAlertDataBySelectedMeterId();
    };
    EmsIndividualDashboardComponent.prototype.updateMeterSelectData = function () {
        var _this = this;
        this.ngxLoader.startLoader('individual_graph');
        if (this.selectedTimeDuration == "Custom") {
            var dialogConfig = new MatDialogConfig();
            var dialogRef = this.matDialog.open(CustomDateComponent, {
                autoFocus: false,
                height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: this.customDateRange }
            });
            dialogRef.afterClosed().subscribe(function (value) {
                var startdate = value.startDate;
                var enddate = value.endDate;
                _this.transMngSer.getEnergyMeterReportData({
                    "meterid": _this.selectedEnergyMeter.split('(')[0],
                    "duration": _this.selectedTimeDuration,
                    "deviceid": _this.selectedDevice.split('(')[0],
                    "range": { "startDate": startdate, "endDate": enddate }
                }).toPromise().then(function (response) {
                    _this.count_m = 1;
                    _this.lastfives = response;
                    _this.lastfive();
                    _this.allDataMeter = _this.sampleData(response.result, 3);
                    _this.updateGraphData();
                });
            });
        }
        else {
            this.transMngSer.getEnergyMeterReportData({
                "meterid": this.selectedEnergyMeter.split('(')[0],
                "duration": this.selectedTimeDuration,
                "deviceid": this.selectedDevice.split('(')[0],
                "range": this.customDateRange
            }).toPromise().then(function (response) {
                if (response.result.length > 0) {
                    _this.count_m = 1;
                    _this.lastfives = response;
                    _this.lastfive();
                    _this.allDataMeter = _this.sampleData(response.result, 3);
                    _this.updateGraphData();
                }
                else {
                    _this.allDataMeter = _this.sampleData(response.result, 3);
                    _this.updateGraphData();
                    _this.ngxLoader.stopLoader('individual_graph');
                }
            });
        }
    };
    EmsIndividualDashboardComponent.prototype.updateGraphData = function () {
        var _this = this;
        var graphDataUpdate = this.allDataMeter.map(function (result) { return ({
            x: result.DATE,
            y: result[_this.selectedParameter],
        }); });
        this.chart_i.updateSeries([{
                data: graphDataUpdate
            }]);
        this.ngxLoader.stopLoader('individual_graph');
    };
    EmsIndividualDashboardComponent.prototype.getAlertDataBySelectedMeterId = function () {
        var _this = this;
        this.EmsdashboardService.getIndividualEnergyMeterAlerts({ "meterId": this.selectedEnergyMeter.split('(')[0] }).toPromise().then(function (response1) {
            if (response1.result.length > 0) {
                _this.LiveAlertsArray = response1.result;
            }
            else {
                _this.LiveAlertsArray = [];
            }
            console.log("?????????????????", _this.LiveAlertsArray);
        });
    };
    EmsIndividualDashboardComponent.prototype.lastfive = function () {
        var response = this.lastfives;
        if (this.count_m <= 5) {
            this.countstepno = this.count_m;
            var lastValue = response.result[response.result.length - this.count_m];
            this.current_l1 = lastValue.l1;
            this.current_l2 = lastValue.l2;
            this.current_l3 = lastValue.l3;
            this.lastUpdateDate = lastValue.DATE;
            this.count_m++;
        }
        else {
            this.count_m = 1;
            this.countstepno = this.count_m;
            var lastValue = response.result[response.result.length - this.count_m];
            this.current_l1 = lastValue.l1;
            this.current_l2 = lastValue.l2;
            this.current_l3 = lastValue.l3;
            this.lastUpdateDate = lastValue.DATE;
            this.count_m++;
        }
    };
    /* ######################################################*/
    // Sample data points by selecting every nth point
    EmsIndividualDashboardComponent.prototype.sampleData = function (data, sampleSize) {
        if (this.selectedTimeDuration == "Last Month" || this.selectedTimeDuration == "This Month" || this.selectedTimeDuration == "This Week") {
            sampleSize = 15;
        }
        var sampledData = [];
        for (var i = 0; i < data.length; i += sampleSize) {
            sampledData.push(data[i]);
        }
        return sampledData;
    };
    EmsIndividualDashboardComponent.prototype.incrementkwh = function () {
        if (this.showInfo === "first") {
            this.showInfo = 'fourth';
        }
        else {
            if (this.showInfo === "fourth") {
                this.showInfo = 'third';
            }
            else {
                if (this.showInfo === "third") {
                    this.showInfo = 'second';
                }
                else {
                    this.showInfo = 'first';
                }
            }
        }
    };
    EmsIndividualDashboardComponent.prototype.resetkwhreset = function () {
        this.showInfo = 'first';
        this.totalkwhcurrentmonth = this.totalkwhcurrentmonth;
        this.pf = this.pf;
        this.latestkwh_p = this.latestkwh_p;
    };
    EmsIndividualDashboardComponent.prototype.showcurrent = function () {
        if (this.showInfo === "first") {
            this.showInfo = 'second';
        }
        else {
            if (this.showInfo === "second") {
                this.showInfo = 'third';
            }
            else {
                if (this.showInfo === "third") {
                    this.showInfo = 'fourth';
                }
                else {
                    this.showInfo = 'first';
                }
            }
        }
    };
    EmsIndividualDashboardComponent.prototype.getPowerFactorHeading = function () {
        if (this.pf < 0.9) {
            return "Low Lagging Power Factor (PF < 0.9)";
        }
        else if (this.pf >= 1) {
            return "High Leading Power Factor (PF > 1 or close to 1)";
        }
        else {
            return "Power Factor is within an acceptable range.";
        }
    };
    EmsIndividualDashboardComponent.prototype.getPowerFactorSuggestion = function () {
        if (this.pf < 0.9) {
            return "- Consider installing power factor correction capacitors to improve the power factor and reduce losses.\n      - Balance the loads across all phases to achieve a more uniform power distribution.\n      - Evaluate the possibility of using more efficient motors or transformers to improve power factor performance.\n      - Identify and address any inefficient or faulty equipment that might be causing the low power factor.";
        }
        else if (this.pf >= 1) {
            return "- If leading power factor correction capacitors are installed, consider reducing or removing them to avoid voltage instability.\n      - Check the proper functioning of capacitors to ensure they are not causing the leading power factor.\n      - Investigate and analyze any capacitive loads or equipment connected to the system that might be contributing to the leading power factor.";
        }
        else {
            return "Power Factor is within an acceptable range.";
        }
    };
    EmsIndividualDashboardComponent.prototype.blink = function () {
        var _this = this;
        this.blinkState = 'hidden';
        setTimeout(function () {
            _this.blinkState = 'visible';
            _this.blink();
        }, 500);
    };
    return EmsIndividualDashboardComponent;
}());
export { EmsIndividualDashboardComponent };
